import { useTranslation } from 'next-i18next';
import { BenefitsBlock } from '@/widgets/BenefitsBlock';
import { MetaDecorator } from '@/shared/utils';
import { getPagesBenefits } from '../lib/pagesBenefits';

const PagesProductPage = () => {
  const { t } = useTranslation();
  const pagesBenefits = getPagesBenefits(t);
  const heading = t('productPages.pages.heading');
  const highlight = t('productPages.pages.highlight', {
    returnObjects: true,
  }) as string[];

  return (
    <>
      <MetaDecorator
        description='meta.products.pages.description'
        keywords='meta.products.pages.keywords'
        title='meta.products.pages.title'
      />
      <BenefitsBlock
        benefits={pagesBenefits}
        heading={heading}
        headingAs='h1'
        highlight={highlight}
        subHeadingAs='h2'
      />
    </>
  );
};

export default PagesProductPage;
